import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, Typography, Button, Result, Alert } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from './auth/AuthContext';
import usePageTracking from '../utils/usePageTracking';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const VerifyResultPage = () => {
  // GA4 页面追踪
  usePageTracking('郵箱驗證結果');
  
  const query = useQuery();
  const status = query.get('status');
  const reason = query.get('reason');
  const navigate = useNavigate();
  const { logout } = useAuth();

  // 如果验证成功，自动登出用户
  useEffect(() => {
    if (status === 'success') {
      logout();
    }
  }, [status, logout]);

  let resultConfig = {};

  if (status === 'success') {
    resultConfig = {
      status: 'success',
      title: '郵箱認證成功',
      subTitle: (
        <div>
          <Typography.Text style={{ 
            fontSize: '16px',
            color: '#666',
            lineHeight: '1.6',
            display: 'block',
            marginBottom: '16px'
          }}>
            您的郵箱已成功認證，歡迎使用本平台全部功能！
          </Typography.Text>
          <Alert
            message="安全提醒"
            description="為了保護您的帳戶安全，系統已自動登出。請使用新驗證的郵箱重新登入。"
            type="info"
            showIcon
            style={{ marginBottom: '16px' }}
          />
        </div>
      ),
      icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />
    };
  } else {
    let errorMessage = '';
    if (reason === 'missing_token') {
      errorMessage = '驗證連結缺少必要資訊，請檢查您的郵件。';
    } else if (reason === 'invalid_or_expired') {
      errorMessage = '認證碼已失效或過期，可能是因為：1) 連結已被使用過 2) 連結已超過24小時有效期 3) 您的郵箱已經驗證過了。';
    } else if (reason === 'server_error') {
      errorMessage = '伺服器錯誤，請稍後再試。';
    } else {
      errorMessage = '認證失敗，請確認您的驗證連結或聯繫客服。';
    }

    resultConfig = {
      status: 'error',
      title: '郵箱認證失敗',
      subTitle: errorMessage,
      icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
    };
  }

  return (
    <div style={{ 
      padding: '24px',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Card style={{ 
        maxWidth: '600px',
        width: '100%',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <Result
          status={resultConfig.status}
          title={
            <Typography.Title level={2} style={{ 
              color: status === 'success' ? '#52c41a' : '#ff4d4f',
              marginBottom: '16px'
            }}>
              {resultConfig.title}
            </Typography.Title>
          }
          subTitle={
            <Typography.Text style={{ 
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6'
            }}>
              {resultConfig.subTitle}
            </Typography.Text>
          }
          extra={[
            status === 'success' ? (
              <Button 
                key="login"
                type="primary" 
                size="large"
                icon={<LoginOutlined />}
                onClick={() => navigate('/')}
                style={{
                  padding: '12px 32px',
                  height: 'auto',
                  borderRadius: '6px',
                  marginRight: '12px'
                }}
              >
                重新登入
              </Button>
            ) : (
              <Button 
                key="resend"
                type="primary" 
                size="large"
                icon={<LoginOutlined />}
                onClick={() => navigate('/profile')}
                style={{
                  padding: '12px 32px',
                  height: 'auto',
                  borderRadius: '6px',
                  marginRight: '12px'
                }}
              >
                重新申請驗證郵件
              </Button>
            ),
            <Button 
              key="home"
              type={status === 'success' ? 'default' : 'primary'}
              size="large"
              icon={<HomeOutlined />}
              onClick={() => navigate('/')}
              style={{
                padding: '12px 32px',
                height: 'auto',
                borderRadius: '6px'
              }}
            >
              {status === 'success' ? '返回首頁' : '返回首頁'}
            </Button>
          ].filter(Boolean)}
        />
      </Card>
    </div>
  );
};

export default VerifyResultPage; 
